<template>
  <div>
    <v-row v-if="showComponent">
      <v-col xl="2" lg="4" md="4" sm="6" xs="6" style="padding: 0 2px 2px 0">
        <v-btn block tile depressed min-height="3.5rem" color="#2c5a90" @click="onOpenTablesDialog">
          <span class="white--text tile btn-md">
            {{ $t("$vuetify.tables.select") }}
          </span>
        </v-btn>
      </v-col>
      <v-col xl="2" lg="4" md="4" sm="6" xs="6" style="padding: 0 2px 2px 0">
        <v-btn block tile depressed min-height="3.5rem" color="#1976d2" @click="onOpenFloorPlanDialog">
          <v-icon left small class="white--text">mdi-floor-plan</v-icon>
          <span class="white--text tile btn-md">
            {{ $t("$vuetify.tables.floorPlan") }}
          </span>
        </v-btn>
      </v-col>
      <v-col xl="2" lg="4" md="4" sm="6" xs="6" style="padding: 0 2px 2px 0">
        <v-btn block tile depressed min-height="3.5rem" color="#2c5a90" @click="onNewOrder">
          <span class="white--text tile btn-md">
            {{ $t("$vuetify.tables.new") }}
          </span>
        </v-btn>
      </v-col>
      <v-col xl="3" lg="6" md="6" sm="12" xs="12" style="padding: 0 2px 2px 0">
        <v-btn :disabled="clearOrderDisabled" block tile depressed min-height="3.5rem" color="#2c5a90" @click="onClearOrder">
          <span class="white--text tile btn-lg">
            {{ $t("$vuetify.tables.clear") }}
          </span>
        </v-btn>
      </v-col>
      <v-col xl="3" lg="6" md="6" sm="12" xs="12" style="padding: 0 0 2px 0">
        <v-btn :disabled="onSaveItemsToTableDisabled" block tile depressed min-height="3.5rem" class="save-btn-glass" @click="onSaveItemsToTable">
          <span v-if="selectedTable.number !== 0" class="btn-text-glass tile btn-lg">
            {{ `${$t("$vuetify.tables.saveTable")}` }}
          </span>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import EventBus from '@/plugins/event-bus'
import { clone } from '@/plugins/utils'
import Table from '@/model/Table'
import state from '@/state'

export default {
  data () {
    return {
      selectedTable: null,
      data: null,
      showComponent: false,
      templateConfig: {
        tables: {
          show: true
        },
        toolbar: {
          buttons: [],
          submenu_options: []
        }
      }
    }
  },
  computed: {
    clearOrderDisabled () {
      return this.selectedTable.number === 0 || this.data.items.length === 0
    },
    onSaveItemsToTableDisabled () {
      return this.selectedTable.number === 0 || this.data.items.length === 0
    }
  },

  methods: {
    onOpenTablesDialog () {
      EventBus.$emit('on-open-tables-dialog')
    },
    onOpenFloorPlanDialog () {
      EventBus.$emit('open-floor-plan-dialog')
    },
    onNewOrder () {
      EventBus.$emit('on-new-order')
    },
    onClearOrder () {
      EventBus.$emit('on-clear-order')
    },
    onSaveItemsToTable () {
      EventBus.$emit('on-save-items-to-table')
    }
  },

  created () {
    const interval = setInterval(() => {
      if (state.getTemplateConfig()) {
        this.templateConfig = state.getTemplateConfig()
        this.showComponent = this.templateConfig.tables && this.templateConfig.tables.show
        clearInterval(interval)
      }
    }, 100)

    this.selectedTable = new Table()

    EventBus.$on('cart-has-changed', (data) => {
      this.data = clone(data)
    })

    EventBus.$on('update-table-selection', (table) => {
      this.selectedTable = table
    })
  },

  beforeDestroy () {
    // ✅ FIX #14: Cleanup EventBus listeners - prevent memory leak
    console.log('🧹 [RegisterTableActions] Čistim EventBus listenere...')
    EventBus.$off('cart-has-changed')
    EventBus.$off('update-table-selection')
    console.log('✅ [RegisterTableActions] EventBus listeneri očišćeni')
  }
}
</script>

<style scoped>
/* Save Button Glass-morphism Styles (Purple) */
.save-btn-glass {
  background: linear-gradient(135deg, rgba(87, 74, 144, 1) 0%, rgba(106, 77, 174, 1) 50%, rgba(87, 74, 144, 1) 100%) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  box-shadow: 0 4px 12px rgba(87, 74, 144, 0.45) !important;
  backdrop-filter: blur(10px) !important;
  -webkit-backdrop-filter: blur(10px) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  border-radius: 12px !important;
}

.save-btn-glass:hover:not(:disabled) {
  background: linear-gradient(135deg, rgba(77, 64, 124, 1) 0%, rgba(96, 67, 154, 1) 50%, rgba(77, 64, 124, 1) 100%) !important;
  box-shadow: 0 8px 20px rgba(87, 74, 144, 0.7) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
  transform: translateY(-2px) scale(1.02);
}

.save-btn-glass:disabled {
  opacity: 0.6 !important;
  background: linear-gradient(135deg, rgba(97, 84, 164, 0.3) 0%, rgba(126, 87, 194, 0.25) 50%, rgba(97, 84, 164, 0.3) 100%) !important;
  box-shadow: 0 1px 4px rgba(97, 84, 164, 0.1) !important;
}

.save-btn-glass:disabled .btn-text-glass {
  color: rgba(255, 255, 255, 0.5) !important;
}

.btn-text-glass {
  color: white !important;
  font-weight: 600 !important;
  letter-spacing: 0.3px !important;
}
</style>
